import {
  Wallet,
  Briefcase,
  Home as HomeIcon,
  Building2,
  Landmark,
  CreditCard,
  Zap,
  Layers,
  Users,
  FileCheck,
  ShieldCheck,
  Headphones,
} from "lucide-react";

export const CONTACT = {
  phone: "+91-7044086479",
  phoneRaw: "917044086479",
  email: "info@carded.in",
  leadEmail: "support@carded.in",
  address: "1340, Madurdaha, Kolkata 700107",
  hours: "Mon – Sat: 10:00 AM – 7:00 PM",
  whatsapp: "917044086479",
};

export const LOAN_TYPES = [
  "Personal Loan",
  "Business Loan",
  "Home Loan",
  "Loan Against Property",
  "Working Capital",
  "Credit Card",
];

export const WHY_CHOOSE = [
  { icon: Zap, title: "Fast Processing", desc: "Quick turnaround from enquiry to disbursement with proactive follow-ups." },
  { icon: Layers, title: "Multiple Bank Options", desc: "Access offers from a wide network of leading Banks and NBFCs." },
  { icon: Users, title: "Experienced Team", desc: "Seasoned advisors who understand lending norms and your profile." },
  { icon: FileCheck, title: "Simple Documentation", desc: "Minimal paperwork with clear, guided checklists at every step." },
  { icon: ShieldCheck, title: "Secure Process", desc: "Your data is handled with strict confidentiality and consent." },
  { icon: Headphones, title: "Dedicated Support", desc: "A single point of contact from application to final approval." },
];

export const LOAN_CATEGORIES = [
  {
    slug: "personal-loan",
    icon: Wallet,
    title: "Personal Loan",
    short: "Instant funds for weddings, travel, medical or any personal need.",
    description:
      "Unsecured personal loans tailored to your income profile, disbursed quickly with flexible tenures. Ideal for planned or emergency expenses without pledging collateral.",
    features: ["Collateral-free funding", "Loan amount up to ₹40 Lakhs*", "Flexible tenure 12–60 months", "Minimal documentation"],
    benefits: ["Quick approvals", "Competitive interest rates", "No end-use restriction", "Multiple lender options"],
    eligibility: ["Salaried or self-employed", "Age 21–60 years", "Stable monthly income", "Fair credit history"],
    documents: ["PAN & Aadhaar", "Latest 3 months salary slips / ITR", "6 months bank statement", "Passport-size photo"],
    image:
      "https://images.pexels.com/photos/34001135/pexels-photo-34001135.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    slug: "business-loan",
    icon: Briefcase,
    title: "Business Loan",
    short: "Fuel expansion, inventory or operations with tailored funding.",
    description:
      "Growth capital for SMEs and enterprises. Whether it is scaling operations, purchasing equipment or managing cash cycles, we match you with the right lender.",
    features: ["Unsecured up to ₹75 Lakhs*", "Tenure up to 60 months", "Overdraft & term loan options", "Quick sanction"],
    benefits: ["Grow without dilution", "Flexible repayment", "Dedicated relationship manager", "Competitive rates"],
    eligibility: ["Business vintage 2+ years", "Minimum annual turnover criteria", "Age 25–65 years", "Healthy financials"],
    documents: ["KYC of proprietor/partners", "GST & ITR (2 years)", "Bank statements (12 months)", "Business proof"],
    image:
      "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBjb25maWRlbnQlMjBidXNpbmVzcyUyMHBlcnNvbiUyMHBvcnRyYWl0fGVufDB8fHx8MTc4Mzk2MDMxM3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "home-loan",
    icon: HomeIcon,
    title: "Home Loan",
    short: "Own your dream home with low rates and long tenures.",
    description:
      "Finance the purchase, construction or renovation of your home with attractive interest rates and extended repayment tenures from top lenders.",
    features: ["High loan-to-value", "Tenure up to 30 years", "Balance transfer options", "Attractive rates"],
    benefits: ["Tax benefits*", "Affordable EMIs", "Top-up facility", "Doorstep assistance"],
    eligibility: ["Salaried or self-employed", "Age 21–65 years", "Stable income", "Good repayment record"],
    documents: ["KYC documents", "Income proof / ITR", "Property papers", "Bank statements (6 months)"],
    image:
      "https://images.pexels.com/photos/33685863/pexels-photo-33685863.jpeg",
  },
  {
    slug: "loan-against-property",
    icon: Building2,
    title: "Loan Against Property",
    short: "Unlock the value of your property for high-value needs.",
    description:
      "Leverage your residential or commercial property to raise substantial funds at lower interest rates for business or personal requirements.",
    features: ["Loan against residential/commercial", "High sanction amount", "Long tenure", "Lower interest vs unsecured"],
    benefits: ["Retain ownership", "Large ticket size", "Flexible use", "Competitive pricing"],
    eligibility: ["Property owner", "Age 21–65 years", "Clear property title", "Stable income"],
    documents: ["KYC documents", "Property title documents", "Income proof / ITR", "Bank statements"],
    image:
      "https://images.unsplash.com/photo-1549757521-4160565ff3de?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBtaW5pbWFsJTIwb2ZmaWNlJTIwYXJjaGl0ZWN0dXJlJTIwYnVpbGRpbmd8ZW58MHx8fHwxNzgzOTYwMzEyfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "working-capital",
    icon: Landmark,
    title: "Working Capital Loan",
    short: "Keep operations smooth with reliable short-term liquidity.",
    description:
      "Manage day-to-day operational expenses, seasonal demand and cash-flow gaps with working capital facilities structured for your business cycle.",
    features: ["Cash credit / overdraft", "Renewable limits", "Interest on utilised amount", "Quick access"],
    benefits: ["Smooth cash flow", "Flexible drawdown", "Supports growth", "Multiple lenders"],
    eligibility: ["Operational business", "Adequate turnover", "GST registered", "Healthy banking"],
    documents: ["KYC of promoters", "GST returns", "Financials & ITR", "Bank statements (12 months)"],
    image:
      "https://images.pexels.com/photos/164501/pexels-photo-164501.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    slug: "credit-card",
    icon: CreditCard,
    title: "Credit Card Assistance",
    short: "Find and apply for the right credit card, effortlessly.",
    description:
      "We help you choose and apply for credit cards that match your spending profile — from cashback and travel to premium lifestyle cards across leading banks.",
    features: ["Card comparison guidance", "Quick application support", "Multiple bank options", "Reward optimisation"],
    benefits: ["Right card for your profile", "Easy documentation", "Faster processing", "Expert guidance"],
    eligibility: ["Age 21+ years", "Stable income", "Fair credit score", "Valid KYC"],
    documents: ["PAN & Aadhaar", "Income proof", "Address proof", "Recent photograph"],
    image:
      "https://images.pexels.com/photos/164501/pexels-photo-164501.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const PROCESS_STEPS = [
  { num: "01", title: "Apply Online", desc: "Share a few details through our quick enquiry form to get started." },
  { num: "02", title: "Document Verification", desc: "Our team guides you through a simple, checklist-based document process." },
  { num: "03", title: "Bank Evaluation", desc: "We present your profile to matched Banks/NBFCs for evaluation." },
  { num: "04", title: "Disbursement", desc: "On approval, funds are disbursed directly to your account." },
];

export const FAQS = [
  { q: "What is a Loan DSA and how does CARDED help me?", a: "A Loan DSA (Direct Selling Agent) connects borrowers with Banks and NBFCs. CARDED helps you compare options, prepare documentation and submit applications to the most suitable lenders — at no impact to the lender's independent decision." },
  { q: "Does submitting an enquiry guarantee loan approval?", a: "No. Submitting an enquiry does not guarantee approval. Loan and credit card approvals are solely at the discretion of the respective Banks/NBFCs based on their internal policies and your eligibility." },
  { q: "Which types of loans can I apply for through CARDED?", a: "Personal Loans, Business Loans, Home Loans, Loan Against Property, Working Capital Loans and Credit Card assistance through our network of partner Banks and NBFCs." },
  { q: "How long does the loan process take?", a: "Timelines vary by lender and loan type. Personal loans can be quick, while secured loans like Home Loans or LAP may take longer due to property and legal verification." },
  { q: "What documents are generally required?", a: "Typically KYC (PAN, Aadhaar), income proof (salary slips or ITR), bank statements and product-specific documents. Our team shares an exact checklist based on your chosen product." },
  { q: "Will CARDED charge me any fees?", a: "Any applicable charges will be communicated to you transparently in advance. Lenders may levy processing fees as per their own policies." },
  { q: "Is my personal information safe with CARDED?", a: "Yes. We handle your information with strict confidentiality and share it with partner Banks/NBFCs only with your consent, in line with our Privacy Policy." },
  { q: "What credit score do I need?", a: "Requirements vary by lender. A healthier credit score generally improves eligibility and pricing, but we work with multiple lenders to find suitable options." },
  { q: "Can self-employed individuals apply?", a: "Yes. Both salaried and self-employed applicants can apply. Documentation and eligibility criteria differ and our advisors will guide you accordingly." },
  { q: "How will you contact me after I apply?", a: "Our representative will reach out via phone, WhatsApp, SMS or email as per your consent to discuss your requirement and next steps." },
  { q: "Can I apply for a balance transfer or top-up?", a: "Yes, balance transfer and top-up options are available on select products such as Home Loans and Personal Loans, subject to lender approval." },
];

export const CREDIT_CARD_BENEFITS = [
  { icon: FileCheck, title: "Easy Documentation", desc: "Streamlined, guided paperwork so you apply without hassle." },
  { icon: Zap, title: "Quick Processing", desc: "Faster application support to reduce waiting time." },
  { icon: Layers, title: "Multiple Bank Options", desc: "Compare cards across leading banks in one place." },
  { icon: ShieldCheck, title: "Secure & Transparent", desc: "Your data stays confidential, with consent-first handling." },
];

export const DISCLAIMER =
  "CARDED is a Loan Direct Selling Agent (DSA). Approval of loans and credit cards is solely at the discretion of the respective Banks/NBFCs. Submission of an enquiry does not guarantee approval.";
